import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ConvertHelper } from '@barthauer/abc/core';
import {
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  QueryColumn,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import {
  AbcAccordionComponent,
  AbcHtmlEditorComponent,
  AbcNumberBoxComponent,
  AbcPopupComponent,
  _AbcButtonComponent,
  _AbcCheckBoxComponent,
  _AbcSelectBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { ApprovalRequest, MeasureProgress } from '@barthauer/custom/xmt-models';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxNumberBoxModule,
  DxSelectBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { EMPTY, forkJoin, from, Observable, of, Subscription } from 'rxjs';
import { concatMap, first, map, switchMap, tap } from 'rxjs/operators';
import { NotificationMessage, ROLES, ToastType } from '../../../../models/enumeration-list.model';
import { AppService } from '../../../../services/app.service';
import { DataService, ObjectKeys } from '../../../../services/data.service';
import { NotificationService } from '../../../../services/notification.service';
import { SharedModule } from '../../../../shared/shared.module';
import { MeasureService } from '../../measure.service';
import {
  EmailNotificationDescriptions,
  EmailNotificationSubjects,
  EmailNotificationType,
  INotificationRecord,
  NotificationService1,
} from '../../../../services/notification1.service';
import { DataService as CoreDataService } from '@barthauer/abc/core/data';
import { RequestStatus } from '../approval-request/enums';
import { AIMSROUTES } from '../../../../../app-routing.module';
import { LanguageService } from '../../../../services/language.service';
import { ObjectTypeService } from '../../../../services/object-type.service';
@Component({
  selector: 'ubt-geods-status-report',
  templateUrl: './status-report.component.html',
  styleUrls: ['./status-report.component.scss'],
  imports: [
    DxTextBoxModule,
    AbcPopupComponent,
    AbcAccordionComponent,
    DxSelectBoxModule,
    DxNumberBoxModule,
    AbcNumberBoxComponent,
    _AbcButtonComponent,
    DxButtonModule,
    SharedModule,
    _AbcCheckBoxComponent,
    DxCheckBoxModule,
  ],
})
export class StatusReportComponent implements OnDestroy, OnInit {
  @ViewChild('progressField') progressField: AbcNumberBoxComponent;
  @ViewChild('confirmDeletePopup') confirmDeletePopup: AbcPopupComponent;
  @Input() lastMeasureProgress: MeasureProgress;
  @Input() measureProgress: MeasureProgress[];
  @Input() measureId: string;
  @Output() assignReportToMeasure: EventEmitter<string> = new EventEmitter();
  @Output() updateReportData: EventEmitter<MeasureProgress> = new EventEmitter();
  @Output() deleteReport: EventEmitter<string> = new EventEmitter();

  private coreDataService = inject(CoreDataService);

  public convertHelper = ConvertHelper;
  public workOnLastStatus = false;
  public isNewMeasureTask = false;
  public date = new Date();
  public disableSave: boolean = true;
  private originalReportData: MeasureProgress;
  private subscriptions: Subscription[] = [];
  toogleTitleVisible: boolean = false;
  public propertyName: string;
  @ViewChild('htmlEditor') htmlEditor: AbcHtmlEditorComponent;
  public fieldValue: string;
  @Input() canManageStatusReport: boolean;
  currentDescriptionField = '';
  constructor(
    public measureService: MeasureService,
    public dataService: DataService,
    private persistenceService: PersistenceService,
    public appService: AppService,
    private notificationService: NotificationService,
    private notificationService1: NotificationService1,
    private cdr: ChangeDetectorRef,
    private languageService: LanguageService,
    private objectTypeService: ObjectTypeService,
  ) {}
  ngOnInit(): void {
    if (this.measureProgress && this.measureProgress?.length > 0) {
      this.measureProgress = this.measureProgress.map((measureprogress) => ({
        ...measureprogress,
        Progress: this.appService.sanitizeContent(measureprogress.Progress),
        NextSteps: this.appService.sanitizeContent(measureprogress.NextSteps),
        Decision: this.appService.sanitizeContent(measureprogress.Decision),
        RiskAndChance: this.appService.sanitizeContent(measureprogress.RiskAndChance),
      }));

      this.navigateToMeasureProgress(-1);
    }
    this.subscriptions.push(
      this.measureService.newStatusReport$.subscribe((status) => {
        this.isNewMeasureTask = status;
      }),
    );
    this.getEditorHeight();
  }
  getEditorHeight(): string {
    if (window.innerWidth <= 480) return '350px';
    if (window.innerWidth <= 768) return '450px';
    return '350px';
  }
  public navigateToMeasureProgress = (index: number): void => {
    this.appService.currentMeasureProgressIndex.set(this.appService.currentMeasureProgressIndex() + index);
    this.lastMeasureProgress = this.measureProgress[this.appService.currentMeasureProgressIndex()];
    this.originalReportData = new MeasureProgress({
      ...this.lastMeasureProgress,
    });
  };

  public persistStatusReport(): void {
    if (!this.lastMeasureProgress.Id) {
      this.addStatusReport();
    } else {
      this.updateStatusReport();
    }
  }

  public verifyChanges(event, propertyField: string, fieldName?: string): void {
    if (event.event) {
      if (event.event.originalEvent.type === 'paste') {
        const sanitizedContent = this.appService.sanitizeContent(propertyField, true);
        this.lastMeasureProgress[fieldName] = sanitizedContent;
        this.currentDescriptionField = this.lastMeasureProgress[fieldName];
        this.htmlEditor.value = sanitizedContent;
      } else {
        this.currentDescriptionField = propertyField;
      }

      if (event.value != undefined) {
        if (!this.originalReportData) {
          this.originalReportData = new MeasureProgress({
            ...this.lastMeasureProgress,
          });
          this.originalReportData[fieldName] = event.previousValue;
        }

        if (fieldName === 'ProgressPercentage') {
          this.measureService.validateNumberField(this.progressField, 0, 100);
        }
        if (this.originalReportData[fieldName] !== event.value) {
          this.disableSave = false;
        } else {
          this.disableSave =
            this.originalReportData.Progress == this.lastMeasureProgress.Progress &&
            this.originalReportData.NextSteps == this.lastMeasureProgress.NextSteps &&
            this.originalReportData.RiskAndChance == this.lastMeasureProgress.RiskAndChance &&
            this.originalReportData.Decision == this.lastMeasureProgress.Decision &&
            this.originalReportData.ProgressPercentage == this.lastMeasureProgress.ProgressPercentage &&
            this.originalReportData.MaturityLevel == this.lastMeasureProgress.MaturityLevel;
        }
      }
    } else {
      this.currentDescriptionField = propertyField;
    }
  }

  public addStatusReport = () => {
    const reportPersistQuery: TargetObjectData = new TargetObjectData();
    reportPersistQuery.ObjectKey = new ObjectKey();
    reportPersistQuery.Mode = PersistMode.Insert;
    reportPersistQuery.ObjectKey.ObjectType = ObjectKeys.MEASUREPROGRESS;
    const progressDate = new Date();

    const reportColumns: TargetColumnValue[] = [
      { Name: 'ParentId', Value: this.measureService.currentMeasureId() },
      { Name: 'Progress', Value: this.lastMeasureProgress.Progress },
      { Name: 'NextSteps', Value: this.lastMeasureProgress.NextSteps },
      { Name: 'RiskAndChance', Value: this.lastMeasureProgress.RiskAndChance },
      { Name: 'Decision', Value: this.lastMeasureProgress.Decision },
      {
        Name: 'ProgressPercentage',
        Value: this.lastMeasureProgress.ProgressPercentage,
      },
      {
        Name: 'MaturityLevel',
        Value: this.measureProgress[this.measureProgress.length - 1]?.MaturityLevel,
      },
      { Name: 'ProgressDate', Value: progressDate.toDateString() },
      {
        Name: 'SysTimeInsert',
        Value: progressDate.getHours() + ':' + progressDate.getMinutes(),
      },
    ];
    reportPersistQuery.TargetColumns = reportColumns;
    const query: PersistObjectModel = new PersistObjectModel();
    query.Object = reportPersistQuery;
    this.subscriptions.push(
      this.getLatestApprovalRequest(this.measureProgress[this.measureProgress.length - 1]?.Id)
        .pipe(
          concatMap((result) => {
            if (Array.isArray(result) && result.length > 0 && result[0].Status == RequestStatus.IN_PROGRESS) {
              this.notificationService.callNotification({
                message: this.dataService.res('Ubt-Measure-Detail-Active-Process-meassage'),
                type: ToastType.INFO,
              });
              return EMPTY;
            }
            return this.persistenceService.executePersistObjectQuery(query).pipe(
              switchMap((persistResult) => {
                const persistedData = {
                  objectType: ObjectKeys.MEASUREPROGRESS,
                  persistedId: persistResult['Id'],
                  ...persistResult,
                };
                return this.measureService
                  .persistProperty(persistedData.persistedId, sessionStorage.getItem('currentProfile'))
                  .pipe(
                    map((resultProperty) => ({
                      measureProgress: persistedData,
                      resultProperty,
                    })),
                  );
              }),
              switchMap((firstResult) =>
                this.measureService.getUsersWithSteeringComitteRole().pipe(
                  map((users: any[]) => ({
                    measureProgressData: firstResult,
                    users: users,
                  })),
                ),
              ),
              switchMap(({ measureProgressData, users }) => {
                if (!users.length) {
                  return of([measureProgressData]);
                }
                const notificationUserIdsInApp: string[] = users
                  .map((u) => {
                    if (u.InAppNotification == true) return u.IdRefPerson;
                  })
                  .filter((u) => u !== undefined);
                const emailEnabledUsers = users.filter((u) => u.EmailNotification == true);

                const notifications: INotificationRecord[] = [
                  {
                    ParentId: measureProgressData.measureProgress.persistedId,
                    ParentObjectType: this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASUREPROGRESS),
                    Comment: 'notification.MeasureProgressCreated',
                    Text: '',
                    UserIdList: notificationUserIdsInApp,
                  },
                ];

                const inApp$ =
                  notificationUserIdsInApp.length > 0
                    ? this.measureService.createNotifications(notifications)
                    : of(null);

                const email$ =
                  emailEnabledUsers.length > 0
                    ? forkJoin(
                        emailEnabledUsers.map((user) =>
                          from(
                            this.languageService.translateBulk(
                              [
                                {
                                  field: 'subject',
                                  key: EmailNotificationSubjects.MEASURE_STATUS_PROGRESS_UPDATED,
                                },
                                {
                                  field: 'description',
                                  key: EmailNotificationDescriptions.MEASURE_STATUS_PROGRESS_UPDATED,
                                  params: {
                                    0:
                                      this.measureService.currentMeasure().Designation ||
                                      this.measureService.currentMeasure().Title,
                                  },
                                },
                                {
                                  field: 'notificationType',
                                  key: EmailNotificationType.MEASURE_STATUS_PROGRESS_UPDATED,
                                },
                              ],
                              user.language ?? 'de',
                            ),
                          ).pipe(
                            switchMap((translations) => {
                              const redirectUrl = this.dataService.generateRedirectionUrl(AIMSROUTES.MEASURE_DETAIL, [
                                AIMSROUTES.MEASURES,
                                this.measureService.currentMeasure().Id,
                              ]);

                              const content = {
                                notificationType: translations.notificationType,
                                description: translations.description,
                                redirectUrl,
                              };

                              return this.notificationService1.sendNotificationEmail(
                                content,
                                translations.subject,
                                user.Email,
                                user.language ?? 'de',
                              );
                            }),
                          ),
                        ),
                      )
                    : of(null);

                return forkJoin([inApp$, email$]).pipe(map(() => [measureProgressData]));
              }),
            );
          }),
        )
        .subscribe(([measureProgressData]: any) => {
          this.assignReportToMeasure.emit(measureProgressData.measureProgress.persistedId);
          this.isNewMeasureTask = false;
          this.measureService.setNewSatusReport(false);
          this.appService.currentMeasureProgressIndex.set(this.appService.currentMeasureProgressIndex() + 1);
          this.lastMeasureProgress.Id = measureProgressData.measureProgress.persistedId;
          this.disableSave = true;
        }),
    );
  };
  public updateStatusReport() {
    const reportPersistQuery: TargetObjectData = new TargetObjectData();
    reportPersistQuery.ObjectKey = new ObjectKey();
    reportPersistQuery.ObjectKey.ObjectType = ObjectKeys.MEASUREPROGRESS;
    reportPersistQuery.Mode = PersistMode.Update;
    reportPersistQuery.ObjectKey.Id = this.lastMeasureProgress.Id;
    const updateReportColumns: TargetColumnValue[] = [
      { Name: 'Progress', Value: this.lastMeasureProgress.Progress },
      { Name: 'NextSteps', Value: this.lastMeasureProgress.NextSteps },
      { Name: 'RiskAndChance', Value: this.lastMeasureProgress.RiskAndChance },
      { Name: 'Decision', Value: this.lastMeasureProgress.Decision },
      {
        Name: 'ProgressPercentage',
        Value: this.lastMeasureProgress.ProgressPercentage,
      },
    ];
    reportPersistQuery.TargetColumns = updateReportColumns;
    const query: PersistObjectModel = new PersistObjectModel();
    query.Object = reportPersistQuery;
    this.subscriptions.push(
      this.persistenceService.executePersistObjectQuery(query).subscribe(
        () => {
          this.updateReportData.emit(this.lastMeasureProgress);
          this.notificationService.callNotification({
            message: NotificationMessage.ValidUpdateMessage,
            type: ToastType.SUCCESS,
          });
          this.disableSave = true;
          this.measureService.setNewSatusReport(false);
        },
        (error) => {
          this.notificationService.callNotification({
            message: NotificationMessage.Error,
            type: ToastType.ERROR,
          });
          console.error(error);
        },
      ),
    );
  }

  public clearProgressFileds = (): void => {
    if (this.workOnLastStatus == false) {
      this.lastMeasureProgress = {
        ...new MeasureProgress(null),
        ProgressDate: this.lastMeasureProgress.ProgressDate,
        ProgressPercentage: this.lastMeasureProgress.ProgressPercentage,
        MaturityLevel: this.lastMeasureProgress.MaturityLevel,
      };
      this.originalReportData = null;
    } else {
      this.lastMeasureProgress = { ...this.lastMeasureProgress };
      delete this.lastMeasureProgress['meta'];
      delete this.lastMeasureProgress.Id;
    }
    this.disableSave = false;
    this.isNewMeasureTask = true;
    this.measureService.setNewSatusReport(true);
  };

  public openConfirmTaskDialog(): void {
    this.confirmDeletePopup.instance.show();
  }

  public abortTaskDelete(): void {
    this.confirmDeletePopup.instance.hide();
  }

  public deleteStatusReport(): void {
    //Delete All Associated Reminders First (ApprovalRequest, ApprovalStep, MeasureProgress)
    const requestOPath = `${this.dataService.getCommentParentTypeBase(ObjectKeys.APPROVAL_REQUEST)}.Type(xmtMeasureProgress)[Id= '${this.lastMeasureProgress.Id}']`;
    const stepOPath = `${this.dataService.getCommentParentTypeBase(ObjectKeys.APPROVAL_STEP)}.ApprovalRequest.Type(xmtMeasureProgress)[Id= '${this.lastMeasureProgress.Id}']`;
    const measureProgress = `${this.dataService.getCommentParentTypeBase(ObjectKeys.MEASUREPROGRESS)}.Id='${this.lastMeasureProgress.Id}'`;
    const oPath = `${requestOPath} OR ${stepOPath} OR ${measureProgress}`;
    this.dataService
      .readObjects(ObjectKeys.REMINDER, [this.coreDataService.createQueryColumn('Id')], oPath)
      .pipe(
        concatMap((reminders) =>
          Array.isArray(reminders) && reminders.length > 0
            ? this.dataService.persistMultipleObjects(ObjectKeys.REMINDER, PersistMode.Delete, reminders)
            : of(null),
        ),
        concatMap(() => this.dataService.deleteObject(ObjectKeys.MEASUREPROGRESS, this.lastMeasureProgress.Id)),
        first(),
      )
      .subscribe({
        next: () => {
          this.deleteReport.emit(this.lastMeasureProgress.Id);
          this.confirmDeletePopup.instance.hide();
          if (this.measureProgress.length == 1) {
            this.lastMeasureProgress = this.measureProgress[0];
            this.originalReportData = new MeasureProgress({
              ...this.lastMeasureProgress,
            });
          } else if (this.measureProgress.length == 0) {
            this.appService.currentMeasureProgressIndex.set(this.appService.currentMeasureProgressIndex() - 1);
            this.lastMeasureProgress = new MeasureProgress(null);
            this.originalReportData = null;
            this.lastMeasureProgress.ProgressDate = new Date();
          } else if (this.measureProgress[this.appService.currentMeasureProgressIndex() + 1]) {
            this.navigateToMeasureProgress(0);
          } else if (this.measureProgress[this.appService.currentMeasureProgressIndex() - 1]) {
            this.navigateToMeasureProgress(-1);
          }
          this.notificationService.callNotification({
            message: NotificationMessage.ValidDeleteMessage,
            type: ToastType.SUCCESS,
          });
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  public IsRoleAuthorizedToUpdate(): boolean {
    if (this.measureProgress && this.measureProgress?.length > 0) {
      if (this.isNewMeasureTask) {
        return !this.canManageStatusReport;
      } else {
        return this.dataService.hasNoMatchingRole([ROLES.Admin]);
      }
    } else if (!this.isNewMeasureTask && this.dataService.hasNoMatchingRole([ROLES.Admin])) {
      return !this.canManageStatusReport;
    }
    return !this.canManageStatusReport;
  }

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }

  public openPopup(fieldValue: string, propertyName: string): void {
    this.propertyName = propertyName;
    this.htmlEditor.value = fieldValue;
    this.toogleTitleVisible = true;
    this.cdr.markForCheck();
  }

  focusIn(fieldValue: string) {
    this.currentDescriptionField = fieldValue;
  }

  saveChanges(propertyName: string, fieldValue: any) {
    this.lastMeasureProgress[propertyName] = fieldValue;
    this.measureService.updateMeasure(propertyName, fieldValue, true);
    this.toogleTitleVisible = false;
  }

  private getLatestApprovalRequest(measureProgressId: string): Observable<Partial<ApprovalRequest>[]> {
    const columns: QueryColumn[] = [this.coreDataService.createQueryColumn('Status')];
    const oPath = `getDateTime(SysDateInsert,SysTimeInsert)=!.cast(xmtMeasureProgress).ApprovalRequests.Max(getDateTime(SysDateInsert,SysTimeInsert)) and ParentId='${measureProgressId}'`;
    return measureProgressId
      ? (this.dataService.readObjects(ObjectKeys.APPROVAL_REQUEST, columns, oPath) as unknown as Observable<
          Partial<ApprovalRequest>[]
        >)
      : of(null);
  }
}
